import {useQueryConfig} from '../Utils';
import ContinentRepository from '../../../networking/repos/ContinentRepository';

const ContinentQueryKey = {
    base: ['continents'],
};

export const useContinentIndexQueryConfig = () => {
    const repo = new ContinentRepository();

    return useQueryConfig(ContinentQueryKey.base, () => repo.all());
};
